import { Action } from '@ngrx/store';
import { Customer } from '@model';

export enum CustomerApprovalsActionTypes {
    LoadDistributionApprovalCustomers = '[CustomerApprovals] Load distribution approval customers',
    LoadDistributionApprovalCustomersSuccess = '[CustomerApprovals] Load distribution approval customers success',
    LoadDistributionApprovalCustomersFail = '[CustomerApprovals] Load distribution approval customers fail',
    LoadDelayedDistributionApprovalCustomerIds = '[CustomerApprovals] Load delayed distribution approval customer ids',
    LoadDelayedDistributionApprovalCustomerIdsSuccess = '[CustomerApprovals] Load delayed distribution approval customer ids success',
    LoadDelayedDistributionApprovalCustomerIdsFail = '[CustomerApprovals] Load delayed distribution approval customer ids fail',
    DelayDistributionApprovalCustomers = '[CustomerApprovals] Delay distribution approval customers',
    DelayDistributionApprovalCustomersSuccess = '[CustomerApprovals] Delay distribution approval customers success',
    DelayDistributionApprovalCustomersFail = '[CustomerApprovals] Delay distribution approval customers fail'
}

export class LoadDistributionApprovalCustomers implements Action {
    readonly type = CustomerApprovalsActionTypes.LoadDistributionApprovalCustomers;
    constructor() {}
}   

export class LoadDistributionApprovalCustomersSuccess implements Action {
    readonly type = CustomerApprovalsActionTypes.LoadDistributionApprovalCustomersSuccess
    constructor(public payload: Customer[]) {}
}

export class LoadDistributionApprovalCustomersFail implements Action {
    readonly type = CustomerApprovalsActionTypes.LoadDistributionApprovalCustomersFail
    constructor(public payload: any) {}
}

export class LoadDelayedDistributionApprovalCustomerIds implements Action {
    readonly type = CustomerApprovalsActionTypes.LoadDelayedDistributionApprovalCustomerIds;
    constructor() {}
}

export class LoadDelayedDistributionApprovalCustomerIdsSuccess implements Action {
    readonly type = CustomerApprovalsActionTypes.LoadDelayedDistributionApprovalCustomerIdsSuccess;
    constructor(public payload: string[]) {}
}

export class LoadDelayedDistributionApprovalCustomerIdsFail implements Action {
    readonly type = CustomerApprovalsActionTypes.LoadDelayedDistributionApprovalCustomerIdsFail;
    constructor(public payload: any) {} 
}

export class DelayCustomerDistributionApprovals implements Action {
    readonly type = CustomerApprovalsActionTypes.DelayDistributionApprovalCustomers
    constructor(public payload: string[]) {}
}

export class DelayCustomerDistributionApprovalsSuccess implements Action {
    readonly type = CustomerApprovalsActionTypes.DelayDistributionApprovalCustomersSuccess
    constructor(public payload: boolean) {}
}

export class DelayCustomerDistributionApprovalsFail implements Action {
    readonly type = CustomerApprovalsActionTypes.DelayDistributionApprovalCustomersFail
    constructor(public payload: any) {}
}

export type CustomerApprovalsActions = 
LoadDistributionApprovalCustomers | 
LoadDistributionApprovalCustomersSuccess | 
LoadDistributionApprovalCustomersFail | 
LoadDelayedDistributionApprovalCustomerIds |
LoadDelayedDistributionApprovalCustomerIdsSuccess |
LoadDelayedDistributionApprovalCustomerIdsFail |
DelayCustomerDistributionApprovals |
DelayCustomerDistributionApprovalsSuccess |
DelayCustomerDistributionApprovalsFail;